import UserMenu from './UserMenu.jsx';

export default function Topbar() {
  return (
    <header className="h-14 border-b border-line bg-panel px-4 flex items-center justify-between">
      <div className="text-sm text-surface-4">
        MiniCRM
      </div>
      <UserMenu />
    </header>
  );
}
